import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import DownloadDialog from "core/document/component/downloadDialog";
import EntitiesEmailDialog from "invoice/component/entitiesEmailDialog";
import {MdCheckbox} from 'core/components/fields/fields';
import documentService from "core/document/documentService";
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, SECURABLE, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {DOCUMENTLOCATION, DocumentCountDto} from "core/document/documentDomain";
import {observer} from "mobx-react";
import {BulkAction, BULKACTIONTYPE} from "core/grid/component/gridComp";
import {extendObservable, action} from "mobx";
import uiService from "core/common/service/uiService";
import {loc} from "core/common/config/locales";
import {PAYMENT_TYPE} from "invoice/domain/invoiceDomain";


const gridLocation = 'issuedInvoiceList';


@observer
export default class IssuedInvoiceList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.invoicing;
  static title = loc.i18n`Issued Invoices`;
  static icon = 'money';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("IssuedInvoiceList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }

  private downloadDialogRef: DownloadDialog;
  private emailDialogRef: EntitiesEmailDialog;


  downloadInvoices = (grid) => {

    new Promise((resolve, reject) => {
      this.downloadDialogRef.open(resolve, reject, {_includeSent: true, _includeByAll: true, _includeAll: false, _byEmail: false, _markSent: false});
    }).catch( (error) => {
      console.log('rejecting DownloadDialog with ', error);
      if (error)  {
        if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
          grid.errors = error.response.data.messages;
        } else {
          throw error;
        }
      }
    });
  };


  emailInvoices = (grid) => {

    new Promise((resolve, reject) => {
      this.emailDialogRef.open(resolve, reject, grid);
    }).catch( (error) => {
      console.log('rejecting EmailDialo with ', error);
      if (error)  {
        if (error.response && error.response.data && error.response.data.severity === 'ERROR') {
          grid.errors = error.response.data.messages;
        } else {
          throw error;
        }
      }
    });
  };




  recount() {
    uiService.showDialogActionFlag();
    return documentService.documentCount("Invoice", DOCUMENTLOCATION.Invoice, documentService.documentCountObject.gridParams)
      .then( (documentCountObjectDto: DocumentCountDto) => {
        extendObservable(documentService.documentCountObject, documentCountObjectDto);
        uiService.hideDialogActionFlag();
      });
  }

  @action onCheckMarkSentByPost = (evt, checked) => {
    console.log('onCheckMarkSentByPost checked: ' + checked);
    documentService.documentCountObject.gridParams._markSent = checked;
    documentService.documentCountObject.gridParams._includeByAll = !checked;
    documentService.documentCountObject.gridParams._includeSent = !checked;
    return this.recount();
  };


  @action onCheckIncludeSent = (evt, checked) => {
    console.log('onCheckIncludeSent checked: ' + checked);
    documentService.documentCountObject.gridParams._includeSent = checked;
    return this.recount();
  };

  @action onCheckByAll = (evt, checked) => {
    console.log('onCheckByAll checked: ' + checked);
    documentService.documentCountObject.gridParams._includeByAll = checked;
    return this.recount();
  };

  @action onCheckIncludeAll = (evt, checked) => {
    console.log('onCheckIncludeAll checked: ' + checked);
    documentService.documentCountObject.gridParams._includeAll = checked;
    return this.recount();
  };


  downloadDialogRefHandler = (comp) => this.downloadDialogRef = comp;
  emailDialogRefHandler = (comp) => this.emailDialogRef = comp;


  render() {
    let {params, query} = this.props;

    let bulkActions: BulkAction[] = [
      {type: BULKACTIONTYPE.ACTION, label: 'Download Invoices for printing', fn: this.downloadInvoices, that:this, securable: SECURABLE.downloadInvoices},
      {type: BULKACTIONTYPE.ACTION, label: 'Email Invoices', fn: this.emailInvoices, that:this, securable: SECURABLE.emailInvoices}
    ];


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)}  entities={mdEntityService.entityMap} gridId={params.gridId} query={query}  bulkActions={bulkActions} multiUpdateSecurable={SECURABLE.invoiceGridUpdate}>
        <ZzFlatButtonRoute onGridToolbar routeName="invoiceDetail" params={{id: 'new'}} query={{paymentTypeId: PAYMENT_TYPE.ACCOUNT_TRANSFER}} label={loc.i18n`New Invoice`} permission={PERMISSION.New} securable={PAGE.invoiceDetail}/>

        <DownloadDialog ref={this.downloadDialogRefHandler} grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap}
                        entityName="Invoice" documentLocation={DOCUMENTLOCATION.Invoice} bodyStyle={DownloadDialog_bodyStyle} >
          {(documentService.documentCountObject && documentService.documentCountObject.gridParams) ?
          <div style={{marginTop:5, marginLeft:20}}>

            <MdCheckbox name="includeAll" checked={documentService.documentCountObject.gridParams._includeAll}
                        label="Include all invoices (canceled, reopened)" onCheck={this.onCheckIncludeAll}/>

            <MdCheckbox name="markSent" checked={documentService.documentCountObject.gridParams._markSent}
                        label="Mark Invoices as Sent via post" onCheck={this.onCheckMarkSentByPost}/>

            {(documentService.documentCountObject.gridParams._markSent) ? (
              <MdCheckbox style={{marginLeft:10}} name="includeSent" checked={documentService.documentCountObject.gridParams._includeSent}
                          label="Include already sent Invoices" onCheck={this.onCheckIncludeSent}/>

            ) : null}
            {(documentService.documentCountObject.gridParams._markSent) ? (
              <MdCheckbox style={{marginLeft:10}} name="includeByAll" checked={documentService.documentCountObject.gridParams._includeByAll}
                          label="Include Invoices to be sent by email" disabled onCheck={this.onCheckByAll}/>
            ) : null}
          </div>
            : null}
        </DownloadDialog>

        <EntitiesEmailDialog ref={this.emailDialogRefHandler} entities={mdEntityService.entityMap} entityName="Invoice" documentLocation={DOCUMENTLOCATION.Invoice} localizedEntitiesName="invoices" entityDetailRoute="invoiceDetail"/>


      </GridCompConnected>
    );
  }

}

const DownloadDialog_bodyStyle = {minHeight: 270};



// WEBPACK FOOTER //
// ./src/invoice/page/issuedInvoiceList.tsx